var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridiconsCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5291 3.4708C10.7666 0.708301 6.2333 0.708301 3.4708 3.4708C0.708301 6.2333 0.708301 10.7666 3.4708 13.5291C6.2333 16.2916 10.6958 16.2916 13.4583 13.5291C16.2208 10.7666 16.2916 6.2333 13.5291 3.4708ZM10.4833 11.475L8.49997 9.49163L6.51663 11.475L5.52497 10.4833L7.5083 8.49997L5.52497 6.51663L6.51663 5.52497L8.49997 7.5083L10.4833 5.52497L11.475 6.51663L9.49163 8.49997L11.475 10.4833L10.4833 11.475Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsCrossCircle);
export default __webpack_public_path__ + "static/media/gridicons_cross-circle.c4460aa35cd3c60c56c63818e00ca153.svg";
export { ForwardRef as ReactComponent };